import { ChatAPI, getChat } from '@guuru/chat-web';
import events from '@guuru/events-web';
import { delegateToClientFormEvent } from '@guuru/chat-events-web';
import { CHANNELS } from '@guuru/chat-common';

const smartForm = {
  async showClientContactForm(partnerId, chatId) {
    const { channel, question } = await getChat(chatId);
    if (channel !== CHANNELS.form.id) {
      return false;
    }
    const {
      smartFormDelegateToClient,
      smartFormDelegateQuestionSelector,
    } = await ChatAPI.getChatSettings(partnerId);
    if (!smartFormDelegateToClient || !smartFormDelegateQuestionSelector) {
      return false;
    }
    events.delegateFormToClient();
    delegateToClientFormEvent(question);
    return true;
  },
};

export default smartForm;
